<template>
  <div class="d-flex flex-column gr-6">
    <div
      class="px-2"
      :class="isMobile ? 'text-h6' : 'text-h5 text-center'"
    >
      {{ t('Отзывы врачей', options) }}
    </div>

    <SliderCards
      v-if="isMobile"
      :doctor-rates="doctorRates"
    />
    <SlidingLineCards
      v-else
      :doctor-rates="doctorRates"
      class="align-self-center"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import useContextStore from 'src/store/useContextStore'
import type { ContextStore } from 'src/components/pages/profile/doctors/register/index/types'
import getDoctorAvatarUrl from 'src/utils/getDoctorAvatarUrl'
import SliderCards from 'src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/DoctorRates/components/SliderCards.vue'
import SlidingLineCards from 'src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/DoctorRates/components/SlidingLineCards.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')
const needTranslate = context.need_translate
const languageIso = context.current_language?.iso ?? ''

const doctorRates = computed(() => context.doctor_rates.map(i => ({
  rateText: transDynamic(i, `rate_text,${languageIso},${needTranslate}`),
  width: `${i.width}px`,
  doctor: {
    id: i.doctor.id,
    fio: i.doctor.fio,
    meta: i.doctor.meta,
    url: i.doctor.url,
    avatar: getDoctorAvatarUrl({ doctor: i.doctor }),
  },
})))
</script>
